import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { PricingCTA } from '../components/PricingCTA';
export function LandingPage() {
  return <main className="min-h-screen w-full font-body selection:bg-gold selection:text-navy-dark" data-id="element-210">
      <HeroSection data-id="element-211" />
      <ProblemSection data-id="element-212" />
      <SolutionSection data-id="element-213" />
      <AudienceSection data-id="element-214" />
      <HowItWorksSection data-id="element-215" />
      <ProofSection data-id="element-216" />
      <PricingCTA data-id="element-217" />

      {/* Simple Footer */}
      <footer className="bg-navy-dark py-8 text-center text-cream-dark/60 text-sm border-t border-white/10" data-id="element-218">
        <div className="container mx-auto px-4" data-id="element-219">
          <p data-id="element-220">
            © {new Date().getFullYear()} El Arca de Efectivo. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 text-xs opacity-60 max-w-2xl mx-auto" data-id="element-221">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </main>;
}